module.exports = __webpack_public_path__ + "img/undefined.6fc49b5e.svg";